import tracker from '../../components/tracker/publish'
import ClampLines from 'react-clamp-lines'

const eventTracker = (item) => {
  const url = `/topic/overview?forumid=${item.id}`

  tracker.trackEvent('userevent', {
    type: 'Category Clicked',
    category_title: item.title,
    category_url: url,
    category_type: 'category',
    click_source: 'parent category'
  })
}

const CategoryListItem = (props) => {
  return (
    <li className='category-page_list-item card-widget-wrapper'>
      <a href={`/topic/overview?forumid=${props.id}`} className='category-page_list-item-link link card-widget-title' onClick={() => eventTracker(props)}>
        <span>
          <ClampLines id='category-list-item' lines={2} text={props.title || ''} buttons={false} />
        </span>
        <i className='icon icon--caret-right' />
      </a>
    </li>
  )
}
export default CategoryListItem
